import { CheckCircle, Clock } from 'lucide-react'; // Usa Lucide o cualquier ícono

const EstadoMatricula = ({ estado }) => {
  return (
    <div className={`badge gap-2 text-white px-4 py-2 rounded-full font-semibold shadow-sm
        ${estado ? 'bg-green-500' : 'bg-red-500'}`}>
      {estado ? (
        <>
          <CheckCircle size={18} />
          Culminado
        </>
      ) : (
        <>
          <Clock size={18} />
          Pendiente
        </>
      )}
    </div>
  );
};

export default EstadoMatricula;
